// Regeln für "Senden setzt fertige Anhänge voraus" (Alex 2026-08-04).
//
// Ausgelagert, weil InputBar.tsx über 2000 Zeilen hat und die Regeln dort weder
// sicht- noch testbar wären. Der Verlust, den sie verhindern, ist still: eine
// Datei landet erst NACH abgeschlossenem Upload in der Anhangsliste, und die
// Sendewege haben das nie geprüft — der Text ging ohne Bild raus, das Feld wurde
// geleert, der Anhang war weg.

export type DispatchDecision = 'go' | 'wait' | 'abort';

/**
 * Darf jetzt gesendet werden?
 *
 * - `wait`: es lädt noch etwas hoch → Absicht merken, gleich ausführen.
 * - `abort`: ein Upload ist fehlgeschlagen → NICHT senden. Ohne diesen Fall
 *   ginge der Text nach dem gescheiterten Upload doch ohne Bild raus, also
 *   genau der Verlust, den die Regel verhindern soll. Der Nutzer behält Text
 *   und Anhänge und entscheidet selbst.
 * - `go`: alles ruhig, senden.
 */
export function dispatchDecision(opts: { uploading: boolean; uploadError?: string }): DispatchDecision {
  if (opts.uploading) return 'wait';
  if (opts.uploadError) return 'abort';
  return 'go';
}

/**
 * Vereinigt die beim Aufnahmestart eingefrorenen Anhang-URLs mit denen, die
 * inzwischen fertig hochgeladen wurden — dedupliziert, Reihenfolge stabil
 * (eingefrorene zuerst).
 *
 * Hintergrund: Der Langdruck-Sprachweg friert Ziel-Agent UND Anhänge bei
 * Aufnahmestart ein, damit ein Tab-Wechsel während der Transkription nicht
 * fehlleitet (#217). Ein Upload, der WÄHREND der Aufnahme fertig wird, fehlt in
 * diesem Schnappschuss. Die Sperre auf den Ziel-Agenten bleibt richtig, der
 * Anhang darf trotzdem nicht verloren gehen.
 */
export function mergeAttachUrls(frozen: string | null | undefined, current: readonly string[]): string {
  const a = (frozen || '').split(' ').filter(Boolean);
  return [...new Set([...a, ...current.filter(Boolean)])].join(' ');
}
